<template>
  <div v-show="visible" class="dialog-tips">
    <div>{{message}}</div>
  </div>
</template>
<script>
export default {
  name: 'Toast',
  data () {
    return {
      visible: false,
      message: ''
    }
  },
  watch: {
    message () {
      if (window.routers.history.current.name === 'home') {
      } else {
        window.routers.push('/')
      }
      var self = this
      setTimeout(function () {
        self.message = ''
      }, 2000)
    }
  }
}
</script>
<style lang="stylus" scoped>
  .dialog-tips
    position fixed
    padding 5px 15px
    text-align center
    background rgba(0,0,0,.5)
    color #fff
    font-size 16px
    top 50%
    left 50%
    display inline-block
    transform translate(-50%,-50%)
    border-radius 15px
</style>



// WEBPACK FOOTER //
// src/components/Toast.vue